"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _trayMenu = require("@ux/tray-menu");
var _reactMintl = require("@godaddy/react-mintl");
var _link = _interopRequireDefault(require("@ux/link"));
var _eid = _interopRequireDefault(require("../eid"));
var _chevronRight = _interopRequireDefault(require("@ux/icon/chevron-right"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/* jscs:disable requireSpacesInsideJsxExpressionContainers */

/**
 * Render Quick Links section.
 *
 * @Constructor
 * @class QuickLinks
 * @api public
 */
class QuickLinks extends _react.Component {
  /**
   * Build the items in a list
   *
   * @param {LinkItem[]} items An array of objects containing the details of a list item
   * @returns {React.ReactElement[]} An array of list items containing a link
   * @api private
   */
  listItemBuilder(items) {
    return items.map(item => {
      const captionOrId = item.caption || item.id;
      const caption = item.caption ? /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
        id: item.caption
      }) : /*#__PURE__*/_react.default.createElement("span", null, item.title);
      return /*#__PURE__*/_react.default.createElement("li", {
        key: captionOrId
      }, /*#__PURE__*/_react.default.createElement(_link.default, {
        urlArgs: this.props.urlArgs,
        href: item.href,
        "data-eid": (0, _eid.default)({
          key: captionOrId,
          manifest: this.props.manifest
        })
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "drop-right"
      }, /*#__PURE__*/_react.default.createElement(_chevronRight.default, null)), caption));
    });
  }

  /**
   * @typedef {Object} LinkItem
   * @prop {LinkItem[]} [children] Array of objects that hold individual list items (caption, href)
   * @prop {String} [caption] Golf string
   * @prop {String} [title] Pre-translated text -- either caption or title must be set
   * @prop {String} [id] Identifier for item -- either caption or ID must be set
   * @prop {String} [href] Optional URL to link to
   */
  /**
   * Build a list
   *
   * @param {LinkItem[]} items An object containing the details for lists to build
   * @returns {Array} An array of lists
   * @api private
   */
  listBuilder(items) {
    if (!items) {
      return;
    }

    // https://github.secureserver.net/UX/eldorado/blob/master/application/includes/all-products-menu.jade#L14-L19

    return items.map(item => {
      const caption = item.caption ? /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
        id: item.caption
      }) : /*#__PURE__*/_react.default.createElement("span", null, item.title);
      return /*#__PURE__*/_react.default.createElement("div", {
        key: item.caption || item.id
      }, /*#__PURE__*/_react.default.createElement("ul", {
        className: "quick-links"
      }, (item.caption || item.title) && /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("strong", null, caption)), this.listItemBuilder(item.children)));
    });
  }
  render() {
    const props = this.props;
    const utilityBarNavs = props.utilityBarNav || [];
    let quickLinks = {};
    for (let i = 0; i < utilityBarNavs.length; i++) {
      const nav = utilityBarNavs[i];
      const captionOrId = nav.caption || nav.id;
      if (captionOrId && ~captionOrId.indexOf('QuickLinks')) {
        quickLinks = nav;
        break;
      }
    }
    if (!quickLinks.caption && !quickLinks.title || !quickLinks.children) {
      return null;
    }
    const caption = quickLinks.caption ? /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: quickLinks.caption
    }) : /*#__PURE__*/_react.default.createElement("span", null, quickLinks.title);
    return /*#__PURE__*/_react.default.createElement(_reactMintl.IntlProvider, {
      locale: props.market,
      messages: props.messages
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "inbox-links"
    }, /*#__PURE__*/_react.default.createElement(_trayMenu.TrayTitle, null, caption), /*#__PURE__*/_react.default.createElement("div", {
      className: "quick-links-container"
    }, this.listBuilder(quickLinks.children))));
  }
}

/**
 * Require properties.
 *
 * @type {Object}
 * @api public
 */
QuickLinks.propTypes = {
  urls: _propTypes.default.object.isRequired,
  market: _propTypes.default.string.isRequired,
  messages: _propTypes.default.object.isRequired,
  utilityBarNav: _propTypes.default.arrayOf(_propTypes.default.object),
  manifest: _propTypes.default.string,
  urlArgs: _propTypes.default.object
};
var _default = QuickLinks;
exports.default = _default;